export default from './Loader';



// WEBPACK FOOTER //
// ./src/sharedComponents/Loader/index.js